export const ManagerTypes = {
    'create'        : 'Manager_create',
    'update'        : 'Manager_update',
    'delete'        : 'Manager_delete',
}